/* eslint-disable */

(function ($) {
  "use strict";

  window.DGS.Components = window.DGS.Components || {};
  window.DGS.Components.ImageSpot = window.DGS.Components.ImageSpot || {};
  window.DGS.Components.ImageSpot.ShouldEqualizeHeader = function () {
    return true;
  };
  window.DGS.Components.ImageSpot.ShouldEqualizeText = function () {
    return true;
  };
  window.DGS.OnLoad.getInstance().register(function () {
    $('.image-spot').each(function () {
      if (window.DGS.Components.ImageSpot.ShouldEqualizeHeader($(this))) {
        window.DGS.EqualHeight.getInstance().register($('.image-spot-element-header', $(this)));
      }
      if (window.DGS.Components.ImageSpot.ShouldEqualizeText($(this))) {
        window.DGS.EqualHeight.getInstance().register($('.image-spot-element-text', $(this)));
      }
    });
  });
  window.DGS.Resizer.getInstance().register(function () {
    $('.image-spot.round-spot:not(.fixed-size):not(.fixed-size-centered) img').each(function () {
      var $this = $(this);
      $this.height('auto').width('auto');
      var height = $this.height();
      var width = $this.width();
      var shorterSide = Math.min(height, width);
      $this.height(shorterSide).width(shorterSide);
    });
  });
})(jQuery);